import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../utils/api';
import toast from 'react-hot-toast';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password || password.length < 8) return toast.error('La contrasena debe tener al menos 8 caracteres');
    if (password !== confirmar) return toast.error('Las contrasenas no coinciden');
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      toast.success('Contrasena actualizada exitosamente');
      navigate('/mi-cuenta');
    } catch(err) {
      toast.error(err.response?.data?.error || 'Token invalido o expirado');
    } finally { setLoading(false); }
  };

  if (!token) return (
    <div style={{ minHeight:'60vh', display:'flex', alignItems:'center', justifyContent:'center' }}>
      <div style={{ textAlign:'center' }}>
        <h2 style={{ fontFamily:'var(--font-display)', color:'var(--forest)' }}>Enlace invalido</h2>
        <a href="/mi-cuenta" style={{ color:'var(--forest)', fontWeight:700 }}>Volver a mi cuenta</a>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight:'60vh', display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
      <div style={{ maxWidth:420, width:'100%' }}>
        <h1 style={{ fontFamily:'var(--font-display)', fontSize:28, color:'var(--forest)', marginBottom:8, textAlign:'center' }}>Nueva contrasena</h1>
        <p style={{ textAlign:'center', color:'var(--ink-faint)', marginBottom:28, fontSize:14 }}>Ingresa tu nueva contrasena</p>
        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">Nueva contrasena</label>
                <input className="form-input" type="password" placeholder="Minimo 8 caracteres" value={password} onChange={e=>setPassword(e.target.value)} required />
              </div>
              <div className="form-group">
                <label className="form-label">Confirmar contrasena</label>
                <input className="form-input" type="password" placeholder="Repite la contrasena" value={confirmar} onChange={e=>setConfirmar(e.target.value)} required />
              </div>
              <button type="submit" className="btn btn-primary" style={{ width:'100%', padding:13, background:'#9FBE6A', color:'#1C3A1E' }} disabled={loading}>
                {loading ? 'Guardando...' : 'Actualizar contrasena'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
